import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDSuT46RON2Y3YWE2qFM1zl9m75P52jVWc",
  authDomain: "inspect.threeclicks.ai",
  projectId: "three-clicks-inspect",
  storageBucket: "three-clicks-inspect.firebasestorage.app",
  messagingSenderId: "668680213971",
  appId: "1:668680213971:web:0f3896559e96c000830b26",
  measurementId: "G-10Z7GV36Z3"
};

const mainApp = initializeApp(firebaseConfig, 'appesteem');
const mainAuth = getAuth(mainApp);
const mainDb = getFirestore(mainApp);
const mainStorage = getStorage(mainApp);

let _reviewApp = null;
function ensureReviewApp() {
  if (!_reviewApp) {
    _reviewApp = initializeApp(firebaseConfig, 'appesteem-review');
  }
  return _reviewApp;
}

export let auth = mainAuth;
export let db = mainDb;
export let storage = mainStorage;

export function switchToReviewFirebase() {
  const reviewApp = ensureReviewApp();
  auth = getAuth(reviewApp);
  db = getFirestore(reviewApp);
  storage = getStorage(reviewApp);
  return { auth, db, storage };
}

export function switchToAppFirebase() {
  auth = mainAuth;
  db = mainDb;
  storage = mainStorage;
  return { auth, db, storage };
}

export default mainApp;
